  import request from "@/utils/request";
  //import { getToken } from "@/utils/auth";

  // 获取baseURL
  //const baseURL = window.global_config?.BASE_URL || ''; 

  export function Downloadfile(filePath) {
    const data = {
    'filePath': filePath,
    };
    //console.log(data);
    return request({
      url: "/interactivedata/downloadfile", 
      method: "post",
      data,
      responseType: 'blob',// 关键：明确指定响应类型
    });
  }
 
  export function DownloadfileDic(filePath) {
    const data = {
      'filePath': filePath,
    };
    return request({
      url: "/interactivedata/downloadfile", 
      method: "post",
      data,
      responseType: 'blob', // 必须设置为 'blob'
    })
    .then(response => {
      // 确保从响应中获取的是 Blob 数据
      const blob = new Blob([response.data], { type: response.data.type || 'application/octet-stream' });
      
      // 创建一个隐藏的下载链接
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = downloadUrl;
      
      // 尝试从响应头中获取文件名
      const contentDisposition = response.headers['content-disposition'];
      let fileName = 'download';
      
      if (contentDisposition) {
        const fileNameMatch = contentDisposition.match(/filename\*?=["']?(?:UTF-8''|'')?([^;"']*)["']?/i);
        if (fileNameMatch && fileNameMatch[1]) {
          // 处理编码的文件名（如 filename*=UTF-8''%E6%96%87%E4%BB%B6.txt）
          fileName = decodeURIComponent(fileNameMatch[1]);
        } else {
          // 处理普通的 filename="文件.txt"
          const fileNameMatch2 = contentDisposition.match(/filename=["']?([^;"']*)["']?/i);
          if (fileNameMatch2 && fileNameMatch2[1]) {
            fileName = fileNameMatch2[1];
          }
        }
      }
      
      link.download = fileName; // 设置下载的文件名
      document.body.appendChild(link);
      link.click(); // 模拟点击下载
      
      // 清理
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
      }, 100);
      
      return response;
    })
    .catch(error => {
      console.error('下载失败:', error);
      throw error;
    });
  }

export function operateinteractivedata(InteractiveInfo) { 
  const data = {
    'content' :
    [
        {
            'id': InteractiveInfo.id,
            'createBy': InteractiveInfo.createBy,
            'createDate': InteractiveInfo.createDate,
            'downloadItemId':InteractiveInfo.downloadItemId,            
            'technologyModeID': InteractiveInfo.technologyModeID,
            'technologyModeName':InteractiveInfo.technologyModeName,
            'description': InteractiveInfo.description,
            'downloadItemName':InteractiveInfo.downloadItemName,
            'viewCount':InteractiveInfo.viewCount,
            'downloadCount': InteractiveInfo.downloadCount,
            'likesCount': InteractiveInfo.likesCount,
            'score': InteractiveInfo.score,
        }
    ],
    'operate': InteractiveInfo.operate 
  };
  return request({
    url: "/interactivedata/operateinteractivedata", 
    method: "post",
    data,
  });
}

export function getleavemessagedatas(messageInfo){
  const data = {
    id: messageInfo.id,
    userId:messageInfo.userId,
    consultItemId: messageInfo.consultItemId,
    isReplied: messageInfo.isReplied,
  }; 
  // console.log(data);
  return request({
    url: "/leavemessagedata/getleavemessagedatas",
    method: "post",
    data,
  });
}
export function operateleavemessagedata(messageInfo){
  const data = {
    'content' :
    [
        {
            'id': messageInfo.id,
            'createBy': messageInfo.createBy,
            'createDate': messageInfo.createDate,
            'userId':messageInfo.userId,            
            'userName': messageInfo.userName,
            'companyName':messageInfo.companyName,
            'phoneNumber': messageInfo.phoneNumber,
            'email':messageInfo.email,
            'city':messageInfo.city,
            'consultItemId': messageInfo.consultItemId,
            'consultItemName': messageInfo.consultItemName,
            'consultContent': messageInfo.consultContent,
            'isReplied': messageInfo.isReplied,
        }
    ],
    'operate': messageInfo.operate 
  };
  console.log(data);
  return request({
    url: "/leavemessagedata/operateleavemessagedata",
    method: "post",
    data,
  });
}